import React from 'react'

// ?import image from '../assets/images/profile/img.jpg'
import image from '../assets/images/profile/img1.JPG'
// import image1 from '../assets/images/overview/img1.jpg'
import logo from '../assets/images/logo/logo.svg'
import { NavLink } from 'react-router-dom'
// import { Carousel } from '../components/Carousel'
import { accordionData } from '../utils'
import Accordion from '../components/Accordion'
import { ImageSlider } from '../components/ImageSlider'
import { Footer } from '../components/Footer'
import { FaAngleDown } from 'react-icons/fa'
import { importImages } from '../utils/importImages'
import pdf from '../assets/NCTM.pdf'

export const Home = () => {
  const slides = importImages(
    require.context('../assets/images/overview', false, /\.(png|jpe?g|svg)$/)
  )

  // const containerStyles = {
  //   width: '25rem',
  //   maxWidth: '90vw',
  //   height: '20rem',
  //   margin: '0 auto',
  // }

  return (
    <>
      {/* header */}
      <header className='header main'>
        {/* card */}
        {/* <div className='center-container initial-section'>
          <div className="flex-center"> */}

        {/* <div className='initial-section'> */}
        <div className='header-content'>
          <div>
            <div>
              <div className='banner-text'>
                <div className='logo-container'>
                  <img src={logo} alt='logo' />
                </div>
                <p className='bolden'>
                  <span>S</span>tella <span>U</span>nica
                </p>
                <p>Music lessons in Nashua, NH</p>
              </div>
            </div>
            {/* !! */}
          </div>
          {/* !! */}
        </div>
        {/* !! */}
        {/* <div className='hero-btn-container'> */}
        {/* <div className='hero-btn-text'>explore</div> */}
        {/* <div className='temp-container'> */}
        {/* <a className='btn' href='#overview'>
              lesson info
            </a> */}
        <a className='hero-btn' href='#intro'>
          <FaAngleDown />
          {/* <FaArrowDown /> */}
        </a>
        {/* </div> */}
        {/* </div> */}
      </header>
      {/* end header */}
      <section id='intro' className='light-lavender'>
        <div className='section-center' style={{ maxWidth: '45rem' }}>
          <h1 className='section-title'>the academy</h1>
          {/* <div className='text-center section-text'> */}
          <p>
            The Music Academy was founded in 2018 by Ph.D. Olga Berkovich, with
            over 25 years of experience in piano tutoring. Olga’s Music Academy
            offers piano lessons at the highest professional level.
          </p>
          <h4>Lesson content includes:</h4>
          <ul
            className='square-list'
            style={{
              marginBottom: '1rem',
            }}
          >
            <li>Piano</li>
            <li>Music Theory (Harmony, Counterpoint, Analysis)</li>
            <li>Music History</li>
            <li>Composition</li>
            <li>Vocal</li>
            <li>Preparation for the RCM and ABRSM international exams</li>
          </ul>
          <p>
            Academy students actively participate in concerts, competitions, and
            festivals, including numerous performances in the famed Carnegie
            Hall in NYC. All academy students have the opportunity to actively
            participate in the master-classes of world-class professors.
          </p>

          <h4>Professional Music Affiliations:</h4>
          <ul className='square-list'>
            <li>MTNA (Music Teachers National Association)</li>
            <li>MMTA (Massachusetts Music Teachers’ Association)</li>
            <li>NHMTA (New Hampshire Music Teachers’ Association)</li>
            <li>NEPTA (New England Piano Teachers’ Association)</li>
            <li>ASCAP (American Society of Composers)</li>
          </ul>
          {/* <br />
          <h4>
            certified teacher of The Royal Conservatory of Music -{' '}
            <a href='https://www.rcmusic.com/teachers/o/olga-berkovich'>RCM</a>{' '}
          </h4> */}
        </div>
        {/* </div> */}
      </section>
      {/* OVERVIEW BEGIN */}
      <section id='overview' className='overview magnolia'>
        <div className='section-center'>
          <h1 className='section-title'>about</h1>
          <div className='about-section flex-container extra-margin'>
            <div className='text-center section-text'>
              <h2>Dr. Olga Berkovich</h2>
              {/* <h3>
                <span>pianist,&nbsp;&nbsp;</span>
                <span>organist,&nbsp;&nbsp;</span>
                <span>composer</span>
              </h3>
              <h3>
                <span>music&nbsp;&nbsp;</span>
                <span>teacher</span>
              </h3> */}

              <h3>pianist, organist, composer, music teacher</h3>
              <br />
              <h3>
                <a href='https://www.rcmusic.com/teachers/o/olga-berkovich'>
                  RCM Certified
                </a>{' '}
                <span>&#10003;</span>
                <br />
                <a href={pdf} target='_blank'>
                  NCTM Certified
                </a>{' '}
                <span>&#10003;</span>
              </h3>
              {/* <ul>
                <li>
                  <h3>
                    <span>pianist</span>
                  </h3>
                </li>
                <li>
                  <h3>
                    <span>organist</span>
                  </h3>
                </li>
                <li>
                  <h3>
                    <span>composer</span>
                  </h3>
                </li>
                <li>
                  <h3>
                    <span>music&nbsp;&nbsp;</span>
                    <span>teacher</span>
                  </h3>
                </li>
                <li>
                  <h3>
                    <span>
                      <a href=''>RCM Certified</a>
                    </span>
                  </h3>
                </li>
              </ul> */}
            </div>
            <article className='profile-img'>
              <div className='profile-pic-container'>
                <img src={image} alt='profile' />
              </div>
            </article>
          </div>
          <div className='flex-container flex-reverse'>
            <div className='section-text'>
              {/* <h2 className='text-center'>music lessons</h2>
              <p>
                I offer my students piano lessons, organ lessons, as well as
                lessons in music theory and composition
              </p> */}
              <h2>dear visitors, </h2>
              <p>
                I'm very excited to welcome you to my personal website, and I'm
                happy to invite you to join my music academy where I offer piano
                lessons for students of ages 5 and above, in addition to lessons
                in music theory and composition.
              </p>
              <div className='centered'>
                <NavLink to='/lessons' className='btn lesson-link'>
                  more info
                </NavLink>
              </div>
            </div>
            {/* <article className='banner-img'>
              <div className='banner-pic-container'>
                <img src={image1} alt='profile' />
                <Carousel />
              </div>
            </article> */}
            <article className='img-slider-frame'>
              <div>
                <ImageSlider slides={slides} />
              </div>
              {/* <div style={containerStyles}>
                <ImageSlider slides={slides} />
              </div> */}
            </article>
          </div>
        </div>
      </section>
      {/* OVERVIEW END */}
      {/* HALL OF FAME START */}
      {/* <section id='overview' className='overview fame-section lavender'>
        <div className='section-center'>
          <div className='hof-title'>
            <h2
              style={{
                marginBottom: '0em',
              }}
              className='section-title special-font'
            >
              our
            </h2>
            <h1 className='section-title' style={{ marginBottom: '0em' }}>
              hall of fame
            </h1>
            <h2 className='section-title special-font'>2024</h2>
          </div>
          <div className='text-center flex-container famer-container'>
            <div className='famer'>
              <h2>Alice Wang</h2>
              <p>
                1st Place – International Concerto Competition (Sempre Musick)
              </p>
              <p>
                1st Place – Performance Competition (Manchester Community Music
                School)
              </p>
              NEW
              <p>2nd place – Judged Festival (Salem State University, MA)</p>
              <p>
                Honorable mention – XVI Chopin Piano Competition (Hartford, CT)
              </p>
              <p>RCM (exam) – Grade 9 (Canada)</p>
            </div>
            <div className='famer'>
              <h2>Angelina Wang</h2>
              <p>
                1st Place – International Concerto Competition (Sempre Music)
              </p>
              <p>
                2nd Place – Performance Competition (Manchester Community Music
                School)
              </p>
              <p>2nd Place – Judged Festival (Salem State University)</p>
              NEW
              <p>
                Honorable mention – XVI Chopin Piano Competition (Hartford, CT)
              </p>
              <p>RCM (exam) – Grade 9, RCM First Class Honor Roll (Canada)</p>
            </div>
            <div className='famer'>
              <h2>Ethan Zhao</h2>
              <p>
                1st Place – Performance Competition (Manchester Community Music
                School)
              </p>
              <p>
                2nd Place – Elite International Music Competition (Carnegie
                Hall, NY)
              </p>
              <p>
                Honorable Mention – Judged Festival (Salem State University)
              </p>
              NEW
              <p>
                1st place – Young Artist Piano Competition (Westfield State
                University, MA)
              </p>
            </div>
            <div className='famer'>
              <h2>Emma Zhao</h2>
              <p>
                1st Place – Elite International Music Competition (Carnegie
                Hall, NY)
              </p>
              <p>
                Honorable Mention – Performance Competition (Manchester
                Community Music School)
              </p>
              <p>
                Honorable Mention – Judged Festival (Salem State University)
              </p>
              NEW
              <p>
                2nd place – Young Artist Piano Competition (Westfield State
                University, MA)
              </p>
            </div>
            <div className='famer'>
              <h2>Kristina Pan</h2>
              <p>
                2nd Place – International Concerto Competition (Sempre Musick)
              </p>
              <p>
                Honorable Mention – Judged Festival (Salem State University)
              </p>
               NEW 
              <p>
                1st place – Young Artist Piano Competition (Westfield State
                University, MA)
              </p>
              <p>3rd place – Judged Festival (Salem State University, MA)</p>
            </div>
            <div className='famer'>
              <h2>Wendy Huang</h2>
              <p>
                1st Place – Elite International Music Competition (Carnegie
                Hall, NY)
              </p>
              <p>
                1st Place – International Concerto Competition (Semite Musick)
              </p>
              <p>1st Place – Judged Festival (Salem State University)</p>
            </div>
            <div className='famer'>
              <h2>Isabella Solari</h2>
              <p>
                1st Place – Young Artist Piano Competition (Westfield State
                University)
              </p>
              <p>
                1st Place – International Concerto Competition (Sempre Musick)
              </p>
               NEW 
              <p>
                1st place (solo) – Little Mozarts International Competitions
              </p>
              <p>
                1st place (duet) – Little Mozarts International Competitions
              </p>
              <p>
                3rd place (solo) – Elite International Music Competition (NY)
              </p>
              <p>
                Honorable mention – Judged Festival (Salem State University, MA)
              </p>
            </div>
            <div className='famer'>
              <h2>Gabriella Solari</h2>
              <p>
                1st Place – Young Artist Piano Competition (Westfield State
                University)
              </p>
              <p>
                2nd Place – International Concerto Competition (SempreMusick)
              </p>
               NEW 
              <p>
                1st place (solo) – Little Mozarts International Competitions
              </p>
              <p>
                1st place (duet) – Little Mozarts International Competitions
              </p>
              <p>
                2nd place (solo) – Elite International Music Competition (NY)
              </p>
            </div>
            <div className='famer'>
              <h2>Billy Solari</h2>
              <p>
                1st Place – Elite International Music Competition (Carnegie
                Hall, NY)
              </p>
              <p>
                1st Place – Young Artist Piano Competition (Westfield State
                University)
              </p>
              <p>
                2nd Place – International Concerto Competition (Sempre Musick)
              </p>
               NEW 
              <p>1st place – Judged Festival (Salem State University, MA)</p>
              <p>1st place – Little Mozarts International Competitions</p>
              <p>2nd place – Elite International Music Competition (NY)</p>
            </div>
            <div className='famer'>
              <h2>Aarav Shroff</h2>
              <p>
                2nd Place – International Concerto Competition (Sempre Musick)
              </p>
               NEW 
              <p>1st place – NYC Miclot International Music Competition (NY)</p>
              <p>1st place – Little Mozarts International Competitions</p>
              <p>2nd place – Winter Serenade Competition (Sempre Music, MA)</p>
              <p>
                2nd place – Elite International Music Competition (Carnegie
                Hall, NY)
              </p>
              <p>
                2nd place – Young Artist Piano Competition (Westfield State
                University, MA)
              </p>
            </div>
            <div className='famer'>
              <h2>Daniel Kan</h2>
              <p>
                1st place – Young Artist Piano Competition (Westfield State
                University, MA)
              </p>
              <p>
                2nd place – Elite International Music Competition (Carnegie
                Hall, NY)
              </p>
              <p>2nd place – NYC Miclot International Music Competition (NY)</p>
            </div>
            <div className='famer'>
              <h2>Keira Bedretdinov</h2>
              <p>
                1st place – Elite International Music Competition (Carnegie
                Hall, NY)
              </p>
              <p>1st place – Little Mozarts International Competitions</p>
              <p>
                3rd place – Young Artist Piano Competition (Westfield State
                University, MA)
              </p>
            </div>
            <div className='famer'>
              <h2>Olivia Chen</h2>
              <p>1st place – Winter Serenade Competition (Sempre Music, MA)</p>
              <p>
                1st place – Young Artist Piano Competition (Westfield State
                University, MA)
              </p>
            </div>
            <div className='famer'>
              <h2>Vincent Vinci</h2>
              <p>
                3rd Place – International Concerto Competition (Sempre Musick)
              </p>
            </div>
            <div className='famer'>
              <h2>Gemma Cohen</h2>
              <p>1st place – Little Mozarts International Competitions</p>
            </div>
            <div className='famer'>
              <h2>Anastasia Baidalo</h2>
              <p>2nd place – Performance Competition (Manchester, NH)</p>
            </div>
            <div className='famer'>
              <h2>Nicholas Drachev</h2>
              <p>1st place – Little Mozarts International Competitions</p>
            </div>
            <div className='famer'>
              <h2>Benjamin Tatashin</h2>
              <p>3rd place – Little Mozarts International Competitions</p>
            </div>
            <div className='famer'>
              <h2>Michael Tatashin</h2>
              <p>3rd place – Little Mozarts International Competitions</p>
            </div>
          </div>
        </div>
      </section> */}
      {/* HALL OF FAME END */}
      {/* {testimonials start} */}
      <section className='light-lavender'>
        <div style={{ paddingTop: '3rem' }}>
          <h1 className='section-title'>Testimonials</h1>
        </div>
        <div className='section-center' style={{ paddingTop: '0' }}>
          {/* 1st testimonial */}
          <div className='flex-container'>
            <article className='testimonial-text'>
              <blockquote>
                <p>
                  Ms. Olga has been mentoring my two daughters since 2020. She
                  is strict, patient, and encouraging. Her lessons are tailored
                  to each student’s interests and characteristics. She
                  encourages my daughters to participate in different recitals
                  and competitions. Over time these experiences build up their
                  confidence. We are very lucky to have her as our piano
                  teacher.
                </p>
              </blockquote>
            </article>
            <div className='section-text'>
              {/* <article className='banner-img testimonial-img'>
                <div className='banner-pic-container'>
                  <img src={image1} alt='profile' />
                </div>
              </article> */}
              <h3>
                - Zixin Lou <br /> (mom of Angelina and Alice)
              </h3>
            </div>
          </div>
        </div>
        {/* 2nd testimonial */}
        <div className='lavender'>
          <div className='section-center'>
            <div className='flex-container flex-reverse'>
              <article className='testimonial-text'>
                <blockquote>
                  <p>
                    Mrs. Olga is the best piano teacher I’ve ever had, and every
                    lesson was filled with her passion and enthusiasm. She cares
                    and loves every single one of her students, and she really
                    tries her best to understand and support us. Mrs. Olga
                    treats us like her own children. She influenced me to not
                    only be a great pianist but also to be a great person.
                  </p>
                </blockquote>
              </article>
              <div className='section-text'>
                <h3>- Wanrui Huang</h3>
              </div>
            </div>
          </div>
        </div>
        {/* 3rd testimonial */}
        <div>
          <div className='section-center'>
            <div className='flex-container'>
              <article className='testimonial-text'>
                <blockquote>
                  {/* ! changes 2026 */}
                  <p>
                    Our family has worked with Olga for over six years, and she
                    has taught all three of my children. She possesses a
                    profound mastery of music that goes far beyond the basics.
                    Her deep knowledge of music theory and performance practice
                    allows her to guide students in understanding exactly how a
                    piece should sound, capturing every small element so the
                    music is performed precisely as the composer intended. ​Olga
                    is wonderful about collaborating with her students, always
                    consulting them to ensure they genuinely connect with a
                    piece before they begin working on it. While she is strict
                    and expects students to come fully prepared, this discipline
                    leads to incredible results—her guidance helped our son win
                    competitions and perform at Carnegie Hall. ​Her emphasis is
                    always on quality over quantity. Under her mentorship, our
                    children have participated in numerous festivals,
                    competitions, and high-level concerts. We couldn't ask for a
                    more dedicated, knowledgeable, or masterful teacher for our
                    children’s musical education.
                  </p>
                </blockquote>
              </article>
              <div className='section-text'>
                {/* changes 2026! */}
                <h3>- Alina Tatashin</h3>
              </div>
            </div>
          </div>
        </div>
        {/* 4th testimonial */}
        <div className='lavender'>
          <div className='section-center'>
            <div className='flex-container flex-reverse'>
              <article className='testimonial-text'>
                <blockquote>
                  <p>
                    When I started taking piano lessons with Olga four years
                    ago, my attitude towards music changed completely. Her
                    energy motivated me to practice and love the music that I
                    was playing. Within a few months after switching to Olga as
                    my teacher, I placed second in my first ever competition.
                    Over the following years, I grew so much as a musician
                    thanks to her passion for teaching and attention to detail.
                    She always found ways to take my playing to the next level
                    and put in every effort to help me improve, from finding
                    masterclasses to showing me the organ. I am most grateful to
                    Olga for what she has taught me and for sharing her love for
                    music with me.
                  </p>
                </blockquote>
              </article>
              <div className='section-text'>
                <h3>- Timothy Kulchitsky (student)</h3>
              </div>
            </div>
          </div>
        </div>
        {/* 5th testimonial */}
        <div>
          <div className='section-center'>
            <div className='flex-container flex-reverse'>
              <article className='testimonial-text'>
                <blockquote>
                  <p>
                    Olga Berkovich has been working with my son Daniel (8 years
                    old) for about 1,5 years. The progress is amazing - second
                    place in Elite Music International Competition at Carnegie
                    Hall, first place in the 2025 Young Artist Piano
                    Competition, second place in the Miclot International
                    Competition etc.
                  </p>
                  <p>
                    Olga is an exceptionally energetic person whose enthusiasm
                    inspires both her students and their parents. She truly
                    believes in a child’s talent and potential and works
                    tirelessly to help it flourish, keeping the child’s interest
                    in music alive and vibrant. Above all, it is her deep,
                    heartfelt care for each of her students that stands out.
                  </p>
                  <p>
                    Olga is also a remarkable manager who has built her studio’s
                    work beautifully. She is the engine of progress, constantly
                    bringing fresh ideas and creative proposals.
                  </p>
                  <p>
                    Dear Olga, we sincerely thank you for your professionalism,
                    enthusiasm and look forward to working with you for many
                    years ahead! You are a wonderful teacher and an interesting,
                    kind-hearted individual.
                  </p>
                </blockquote>
              </article>
              <div className='section-text'>
                <h3>- Oksana Kan</h3>
              </div>
            </div>
          </div>
        </div>
        {/* <Carousel /> */}
        {/* <div className='carousel-container'>
            <div className='carousel-item'>
              <h1>Item 1</h1>
            </div>
            <div className='carousel-item'>
              <h1>Item 2</h1>
            </div>
            <div className='carousel-item'>
              <h1>Item 3</h1>
            </div>
          </div> */}
      </section>
      {/* testimonials end */}
      <section className='questions magnolia'>
        <div className='questions-container'>
          <h1 className='section-title'>FAQs</h1>
          <div className='accordion-container'>
            {accordionData.map((data, index) => (
              // console.log(data)
              // const { title, content } = data

              <Accordion
                key={index}
                title={data.title}
                content={data.content}
              />
            ))}
          </div>
        </div>
      </section>
      <Footer />
      {/* <footer className='footer'>
        <h4 class='footer-text'>
          &copy; <span id='date'></span>
          <span class='company'>olga berkovich's music academy </span>
          <br /> all rights reserved
        </h4>
      </footer> */}
    </>
  )
}
